import { lazy } from "react";

const SystemVariantsPage = lazy(
  () => import("@/widgets/system-admin/variants/SystemVariantsPage"),
);

const SystemVariantsRoutes = {
  path: "variants",
  children: [{ index: true, element: <SystemVariantsPage /> }],
};

export default SystemVariantsRoutes;
